import type React from "react";
import { ReactComponent as Svg } from "./assets/danger.svg";
import * as styles from "./Icon.module.scss";

type DangerProps = React.SVGProps<SVGSVGElement>;

export const Danger = ({ className, ...props }: DangerProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
